import type { FC } from 'react';
import styles from './DeliveryHeaderPanel.module.css';
import type { DeliveryHeaderPanelProps } from './DeliveryHeaderPanel.types';

export const DeliveryHeaderPanel: FC<DeliveryHeaderPanelProps> = ({
  children,
}) => {
  return <nav className={styles.panelHeader}>{children}</nav>;
};
